import MatchlibClient from 'matchlib-lambda-client';

const matchlib = MatchlibClient({
  url: 'https://5kp0a8sjm6.execute-api.ap-southeast-2.amazonaws.com/matchlib',
});

(window as any).matchlib = matchlib; // tslint:disable-line

export default matchlib;



// WEBPACK FOOTER //
// ./src/state/matchlib.ts